import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { Translation } from '../i18n/translation.service';
import { normalizeStoredLanguage, readStoredLanguage } from '../i18n/language-storage';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const auth = inject(AuthService);
  const router = inject(Router);
  const translation = inject(Translation);

  const stored = readStoredLanguage();
  const fromTranslate =
    translation.translateService.getCurrentLang() || translation.translateService.getFallbackLang() || 'en-US';
  const currentLang = normalizeStoredLanguage(stored ?? fromTranslate);

  const token = auth.getAccessToken();
  const withAuth = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Accept-Language': currentLang
        }
      })
    : req.clone({
        setHeaders: {
          'Accept-Language': currentLang
        }
      });

  return next(withAuth).pipe(
    catchError((err: unknown) => {
      // 401 is handled by `adminAuthRefreshInterceptor` (refresh + retry); only redirect if refresh did not apply.
      if (err instanceof HttpErrorResponse && err.status === 401 && req.headers.has('X-Auth-Retry')) {
        auth.clear();
        void router.navigateByUrl('/login');
      }
      return throwError(() => err);
    })
  );
}

